import { all, takeEvery, put, call } from 'redux-saga/effects'
import { getLeftMenuData } from 'services/menu'
import actions from './actions'

export function* GET_DATA() {
  
  const menuLeftData = yield call(getLeftMenuData)
  yield put({
    type: 'menu/SET_STATE',
    payload: {
      menuLeftData,
    },
  })
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.GET_DATA, GET_DATA),
    GET_DATA(), // run once on app load to fetch menu data
  ])
}
